import Cookies from 'js-cookie';
import { currentMonth, currentYear } from '../util';
import ApiValuation from '../valuation/api';
import UserAPI from '../user/api';
import { user, auth } from '../auth';

const COOKIE_USER_PROFILE_LAST_UPDATE = "userProfileLastUpdate";
const COOKIE_USER_PROFILE_LAST_UPDATE_EXPIRATION = 60 * 60 * 12; // Cada 12 horas

/**
 * TODO: separar store por componentes/app
 */
const actions = {
  initApp({dispatch}) {
    dispatch('initUser');
  },

  async initUser({commit}) {
    if (!user.isLogged) {
      // Eliminamos esta clave por si acaso un equipo es usado por mas de una persona
      localStorage.removeItem(`likes_${currentYear}_${currentMonth}`);
    }

    if (user.isLogged && !user.accessDate) {
      console.debug("Refreshing user last access Date")
      await UserAPI.postLastAccess();
    }

    const {
      id: userId,
      isPartner,
      avatarUrl,
      nick,
      userType,
      status,
      statusText,
      tarjetaCaducada,
      periodoGracia,
      carrito,
    } = user;
    const { loginUrl, redirectUrl, partnerUrl, profileUrl, increaseQuotaUrl, registerUrl } = auth;

    commit('INIT_USER_STATE', {
      loginUrl,
      redirectUrl,
      partnerUrl,
      userId,
      userType,
      status,
      statusText,
      isPartner,
      avatarUrl,
      nick,
      profileUrl,
      increaseQuotaUrl,
      registerUrl,
      tarjetaCaducada,
      periodoGracia,
      carrito,
    });

    // Actualiza las cookies del usuario cada "COOKIE_USER_PROFILE_LAST_UPDATE_EXPIRATION"
    let updateUserProfile = async () => {
      if (Cookies.get(COOKIE_USER_PROFILE_LAST_UPDATE) !== undefined) {
        return;
      }

      const response = await UserAPI.getUserProfile();
      if (response && response.success) {
        const expires = Math.floor(Date.now() / 1000) + COOKIE_USER_PROFILE_LAST_UPDATE_EXPIRATION;
        Cookies.set(COOKIE_USER_PROFILE_LAST_UPDATE, 1, { expires });
      }
    }

    if (user.isLogged) {
      await updateUserProfile();
    }
  },

  async valuate({commit}, contentId) {
    const response = await ApiValuation.valuate(contentId);
    if (response.success) {
      let likes = localStorage.getItem(`likes_${currentYear}_${currentMonth}`);
      likes = likes?likes.split(','):[];
      if (
        likes &&
        (likes.indexOf(`${contentId}`) === -1)
      ) {
        likes.push(`${contentId}`);
      }
      localStorage.setItem(`likes_${currentYear}_${currentMonth}`, likes.filter(like => like !== "").join(','));
    }
    return response;
  },

  async undoValuation({commit}, contentId) {
    const response = await ApiValuation.undoValuation(contentId);
    if (response.success) {
      let likes = localStorage.getItem(`likes_${currentYear}_${currentMonth}`);
      likes = likes?likes.split(','):[];
      if (likes.length > 0) {
        likes.forEach((contentIdSaved, index) => {
          if (parseInt(contentIdSaved) === contentId) {
            likes.splice(index, 1);
          }
        });
      }
      localStorage.setItem(`likes_${currentYear}_${currentMonth}`, likes.join(','));
    }
    return response;
  },

  async checkValuatedContents({ getters }) {
    if (!localStorage.getItem(`likes_${currentYear}_${currentMonth}`) && getters.isLogged) {
      if (!localStorage.getItem(`valuation_in_progress_likes_${currentYear}_${currentMonth}`)) {
        const {results} = await ApiValuation.checkContents();
        if (results) {
          const {contents} = results;
          localStorage.setItem(`likes_${currentYear}_${currentMonth}`, contents.join(','));
        }
        localStorage.removeItem(`valuation_in_progress_likes_${currentYear}_${currentMonth}`);
      }
    }
  }
};

export default actions;
